import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { Toast } from 'primereact/toast';
import { setToastMessage } from '../products/productsSlice';
const Notifications = () => {
    const toast = useRef(null);
    const dispatch = useAppDispatch();
    const { toastMessage } = useAppSelector((state) => state.products);
    const renderMessage = () => {
        var _a;
        if (toastMessage) {
            (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'info', summary: 'Confirmed', detail: toastMessage, life: 5000 });
            dispatch(setToastMessage(''));
        }
        return null;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Toast, { ref: toast, position: "bottom-right" }), renderMessage()] }));
};
export default Notifications;
